export const styles = {
  offeringCard: 'tw-p-3 tw-border-solid tw-border tw-border-neutral-200 tw-rounded',
  offeringHeader: 'tw-flex tw-items-center tw-justify-between tw-gap-2',
  offeringName: 'tw-text-sm tw-font-medium tw-text-neutral-800',
  offeringTags: 'tw-flex tw-flex-wrap tw-gap-1 tw-mt-2',
  tooltipContent: 'tw-flex tw-flex-wrap tw-gap-1.5',
};
